// import {fetchInfo} from '@/devicehq/api/info'
import {DEVICEHQ} from '@/devicehq/api'

const getInfo = context => {
  // fetchInfo
  DEVICEHQ.get('/api/v2/info', {
    data: {},
  })
    .then(response => {
      context.commit('INFO_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

export default {
  getInfo,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/info/actions.js